import { Modal } from '@veneer/core';
import styled from 'styled-components';

import {
  color,
  layout,
  typography,
  minDesktopLarge,
  minDesktopRegular,
  minDesktopSmall,
  minDesktopXS,
  minMobile,
  minTablet,
} from '../../GlobalStylesVisid';

export const ModalContainer = styled(Modal)`
  && {
    border-radius: ${layout.cornerRadius4}px;
    width: 343px;
    padding: ${layout.size6}px;

    ${minMobile} {
      width: 448px;
    }
    ${minTablet} {
      width: 704px;
      padding: 40px ${layout.size6}px 40px 40px;
    }
    ${minDesktopXS} {
      width: 715px;
    }
    ${minDesktopSmall} {
      width: 781px;
    }
    ${minDesktopRegular} {
      width: 952px;
    }
    ${minDesktopLarge} {
      width: 1064px;
    }

    [class~='vn-modal__close'] {
      color: ${color.gray12};
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${layout.size6}px;
`;

export const Title = styled.div`
  top: 0;
  color: ${color.gray12};
  text-align: left;
  background-color: ${color.white};
  padding-right: 20px;
`;

export const ScrollbarWrapper = styled.div`
  box-sizing: border-box;
  max-height: 596px;
  padding-right: 20px;
  overflow: overlay;

  &::-webkit-scrollbar {
    width: 6px;
    background-clip: content-box;
    border: 2px solid transparent;
    &-thumb {
      border-radius: 2px;
      background: ${color.gray6};
    }

    &-track {
      display: none;
    }
  }
`;

export const ContainerRows = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  gap: ${layout.size4}px;
  ${minTablet} {
    gap: 20px;
  }
  ${minDesktopSmall} {
    gap: ${layout.size6}px;
  }
`;

export const ContainerColumn = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 130px;
  ${minMobile} {
    width: 182px;
  }
  ${minTablet} {
    width: 300px;
  }
  ${minDesktopXS} {
    width: 197px;
  }
  ${minDesktopSmall} {
    width: 216px;
  }
  ${minDesktopRegular} {
    width: 273px;
  }
  ${minDesktopLarge} {
    width: 311px;
  }
`;

export const Header = styled.div`
  top: 0px;
  position: sticky;
  display: flex;
  flex-direction: column;
  background-color: ${color.white};
  align-items: center;
  border-bottom: 1px solid ${color.gray12};
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${layout.size8}px;
  width: 130px;
  ${minMobile} {
    width: 182px;
  }
  ${minTablet} {
    width: 300px;
  }
  ${minDesktopXS} {
    width: 197px;
  }
  ${minDesktopSmall} {
    width: 216px;
  }
  ${minDesktopRegular} {
    width: 273px;
  }
  ${minDesktopLarge} {
    width: 311px;
  }

  div[class$='base-combobox-TextBox'] {
    min-width: 130px;
  }
  input[id^='select-printer'] {
    padding-top: 6px;
    padding-bottom: 6px;
    min-width: 130px;
    border: solid ${color.gray7} 1px;
    line-height: 28px;
  }
  svg[class^='vn-icon'] {
    fill: ${color.gray7};
  }
  [role='option'][aria-selected='true'] {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 110px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Image = styled.img`
  max-width: 130px;
  padding-bottom: ${layout.size6}px;
`;

export const FeatureUnitSpecs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${layout.size4}px;
`;

export const FeatureNameSpecs = styled.a`
  display: flex;
  justify-content: center;
  color: ${color.electricBlue7};
  word-wrap: break-word;
  line-height: ${typography.lineHeight2};
  gap: ${layout.size1}px;

  &:hover {
    color: ${color.electricBlue7};
  }

  &:visited {
    color: ${color.electricBlue7};
  }
`;

export const FeatureNameText = styled.span`
  color: ${color.electricBlue7};

  &:hover {
    color: ${color.electricBlue7};
  }

  &:visited {
    color: ${color.electricBlue7};
  }
`;

export const FeatureDescription = styled.div`
  color: ${color.gray7};
  word-wrap: break-word;
`;

export const Feature = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
`;

export const FeatureUnit = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: ${layout.size4}px;
  color: ${color.gray9};
  border-top: 1px solid ${color.gray3};
  ${minMobile} {
    min-height: 14px;
  }
`;

export const FeatureName = styled.div`
  word-wrap: break-word;
  text-align: center;
`;

export const FeatureNumber = styled.div`
  display: flex;
  justify-content: center;
`;

export const FeatureNone = styled.hr`
  width: ${layout.size4}px;
  height: 1px;
  background-color: ${color.gray9};
  margin: ${layout.size2}px 0;
  }
`;
